import React from "react";

const Map = () => {
  return (
    <div className="mapSection" id="map">
      <h2>FIND US HERE</h2>
      <iframe
        title="findUs"
        className="map-iframe"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2874.452960064844!2d15.693945676387413!3d43.90859543587488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1334d5bdbf0f0679%3A0x5c2637f2bea10575!2sVilla%20Adriart!5e0!3m2!1sen!2shr!4v1715425250064!5m2!1sen!2shr"
      ></iframe>
    </div>
  );
};

export default Map;
